// src/utils/downloadUtils.js

/**
 * Fetches a file from a URL and forces the browser to download it.
 * @param {string} url - The URL of the file to download
 * @param {string} customFilename - Optional custom filename for the downloaded file
 */
export const downloadFileFromUrl = async (url, customFilename) => {
  if (!url) throw new Error("No URL provided");

  const response = await fetch(url);
  if (!response.ok) throw new Error("Network response was not ok");
  
  const blob = await response.blob();
  
  // Extract the filename from the URL (and decode spaces like %20)
  const filenameRaw = customFilename || url.split('/').pop();
  const filename = decodeURIComponent(filenameRaw);

  // Create a temporary local URL for the blob
  const blobUrl = window.URL.createObjectURL(blob);
  
  // Create a hidden <a> tag and click it programmatically
  const link = document.createElement("a");
  link.href = blobUrl;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  
  // Cleanup
  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
};